<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="工号" prop="zygh">
                <el-input clearable v-model="dataForm.zygh" @change="changeZygh" :disabled="dataForm.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="zyxm">
                <el-input clearable v-model="dataForm.zyxm" :disabled="dataForm.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="岗位名称" prop="gwmc">
                <el-input clearable v-model="dataForm.gwmc" :disabled="dataForm.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="基本工资" prop="jbgz">
                <el-input clearable v-model="dataForm.jbgz" ></el-input>
            </el-form-item>
            <el-form-item label="岗位津贴" prop="gwjt">
                <el-input clearable v-model="dataForm.gwjt" ></el-input>
            </el-form-item>
            <el-form-item label="值班津贴" prop="zbjt">
                <el-input clearable v-model="dataForm.zbjt" ></el-input>
            </el-form-item>
            <el-form-item label="叠加护校津贴" prop="djhxjt">
                <el-input clearable v-model="dataForm.djhxjt" ></el-input>
            </el-form-item>
            <el-form-item label="考核奖" prop="khj">
                <el-input clearable v-model="dataForm.khj" ></el-input>
            </el-form-item>
            <el-form-item label="津贴1" prop="jt1">
                <el-input clearable v-model="dataForm.jt1" ></el-input>
            </el-form-item>
            <el-form-item label="职位津贴" prop="zwjt">
                <el-input clearable v-model="dataForm.zwjt" ></el-input>
            </el-form-item>
            <el-form-item label="饭贴" prop="ft">
                <el-input clearable v-model="dataForm.ft" ></el-input>
            </el-form-item>
            <el-form-item label="其他2" prop="qt2">
                <el-input clearable v-model="dataForm.qt2" ></el-input>
            </el-form-item>
            <el-form-item label="独生子女费" prop="dsznf">
                <el-input clearable v-model="dataForm.dsznf" ></el-input>
            </el-form-item>
            <el-form-item label="其他1" prop="qt1">
                <el-input clearable v-model="dataForm.qt1" ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="bz">
                <el-input type="textarea" clearable v-model="dataForm.bz" ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data () {
            const validateNumber = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            return {
                visible: false,
                //表单验证规则
                rules: {
                    zygh: [{required: true, trigger: 'blur', message: '请输入工号'}],
                    zyxm: [{required: true, trigger: 'blur', message: '请输入姓名'}],
                    gwmc: [{required: true, trigger: 'blur', message: '请输入岗位名称'}],
                    jbgz: [{validator:validateNumber,trigger: 'blur'}],
                    gwjt: [{validator:validateNumber,trigger: 'blur'}],
                    zbjt: [{validator:validateNumber,trigger: 'blur'}],
                    djhxjt: [{validator:validateNumber,trigger: 'blur'}],
                    khj: [{validator:validateNumber,trigger: 'blur'}],
                    jt1: [{validator:validateNumber,trigger: 'blur'}],
                    zwjt: [{validator:validateNumber,trigger: 'blur'}],
                    ft: [{validator:validateNumber,trigger: 'blur'}],
                    qt2: [{validator:validateNumber,trigger: 'blur'}],
                    dsznf: [{validator:validateNumber,trigger: 'blur'}],
                    qt1: [{validator:validateNumber,trigger: 'blur'}]
                },
                dataForm: {
                    id: '',
                    zygh: '',
                    zyxm: '',
                    gwmc: '',
                    jbgz: '',
                    gwjt: '',
                    zbjt: '',
                    djhxjt: '',
                    khj: '',
                    jt1: '',
                    zwjt: '',
                    ft: '',
                    qt2: '',
                    dsznf: '',
                    qt1: '',
                    bz: '',
                    month: '',
                    bmid: '',
                    bmmc: '',
                    gzlx: '',
                    hj: '',
                    js: ''
                },
                month: ''
            }
        },
        methods: {
            init (val,month) {
                this.visible = true
                this.month = month
                this.$refs['dataForm'].resetFields()
                this.dataForm.id = ''
                this.dataForm.bmid = ''
                this.dataForm.bmmc = ''
                this.dataForm.gzlx = ''
                this.dataForm.hj = ''
                this.dataForm.js = ''
                this.dataForm.bz = ''
                if(val) {
                    this.dataForm = Object.assign({},val)
                }
            },
            // 表单提交
            dataFormSubmit () {
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.dataForm.month = this.month
                    this.$http({
                        url: this.dataForm.id ? `/bjba/salary/school/update` : `/bjba/salary/school/save`,
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                        if (data && data.code === 200) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500
                            })
                            this.visible = false
                            this.$emit('refreshDataList')
                        } else if(data && data.code === 500) {
                            this.$message({
                                message: data.message,
                                type: 'error',
                                duration: 1500
                            })
                        }
                    })
                }
             })
            },
            changeZygh(e) {
                this.$request.get('/bjba/gzkquser/findUserInfo',{
                    params: {
                        username: e
                    }
                }).then(res => {
                    if (res.status == 200 && res.data.data.length != 0) {
                        var userInfo = res.data.data[0]
                        this.dataForm.zyxm = userInfo.xm
                        this.dataForm.gwmc = userInfo.gw
                        this.dataForm.bmid = userInfo.zzdyqc
                    }
                });
            }
        }
    }
</script>
